import { useMemo } from 'react'

export default function Table({ filteredOffers, activePage, translation }) {
  const firstTwoOffers = useMemo(
    () => filteredOffers
      .filter((o) => new Date(o.endDate) >= new Date(new Date().toDateString()))
      .slice(activePage * 10, (activePage * 10) + 2),
    [activePage, filteredOffers]
  )

  return (
    <div className='inner-container shadow-slider border-collapse bg-white rounded-t mt-6 overflow-x-auto w-full'>
      <div className='table-container bg-gray-350 text-gray-light'>
        <p className='!text-base !text-gray-light'>{translation?.code}</p>
        <p className='!text-base'>{translation?.details}</p>
        <p className='!text-base !text-gray-light'>{translation?.expiresin}</p>
      </div>
      <div className=''>
        {firstTwoOffers.map((offer, index) => {
          return <div key={index} className='table-container'>
            <p>{offer.code}</p>
            <p className='!line-clamp-1 !py-0 my-2'>{offer.title}</p>
            <p>{offer.endDate || '---'}</p>
          </div>
        })}
      </div>
    </div>
  )
}